const style = {
  row: {
    border: `1px solid transparent`,
    padding: `20px`,
    borderBottom: `1px solid #f4f4f4`,
    cursor: `pointer`,
    ':hover': {
      border: `1px solid #ececec`,
      background: `#fbfbfb`,
      borderRadius: `3px`
    }
  },
  activeRow: {
    border: `1px solid #ececec`,
    background: `#fbfbfb`,
    borderRadius: `3px`
  },
  header: {
    borderBottom: `1px solid #ececec`,
    padding: `10px 20px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/RevenueTable/style/list.js